import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PosPage } from './pos.page';

const routes: Routes = [
  {
    path: '',
    component: PosPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PosPageRoutingModule {}
